import axios from 'axios';
import swal from 'sweetalert';

export var CREATE_NEW_TEMPLATE_START = "CREATE_NEW_TEMPLATE_START";
export var CREATE_NEW_TEMPLATE_SUCCESS = "CREATE_NEW_TEMPLATE_SUCCESS";
export var CREATE_NEW_TEMPLATE_FAILURE = "CREATE_NEW_TEMPLATE_FAILURE";

export var UPDATE_TEMPLATE_START = "UPDATE_TEMPLATE_START";
export var UPDATE_TEMPLATE_SUCCESS = "UPDATE_TEMPLATE_SUCCESS";
export var UPDATE_TEMPLATE_FAILURE = "UPDATE_TEMPLATE_FAILURE";

export var DELETE_SIGNATURE_START = "DELETE_SIGNATURE_START";
export var DELETE_SIGNATURE_SUCCESS = "DELETE_SIGNATURE_SUCCESS";
export var DELETE_SIGNATURE_FAILURE = "DELETE_SIGNATURE_FAILURE";

export var FETCH_SIGNATURE_START = "FETCH_SIGNATURE_START";
export var FETCH_SIGNATURE_SUCCESS = "FETCH_SIGNATURE_SUCCESS";
export var FETCH_SIGNATURE_FAILURE = "FETCH_SIGNATURE_FAILURE";

export var FETCH_TWEETS_START = "FETCH_TWEETS_START";
export var FETCH_TWEETS_SUCCESS = "FETCH_TWEETS_SUCCESS";
export var FETCH_TWEETS_FAILURE = "FETCH_TWEETS_FAILURE";

export var FETCH_INSTAGRAM_START = "FETCH_INSTAGRAM_START";
export var FETCH_INSTAGRAM_SUCCESS = "FETCH_INSTAGRAM_SUCCESS";
export var FETCH_INSTAGRAM_FAILURE = "FETCH_INSTAGRAM_FAILURE";

var URL = '/api/signature';
var axiosConfig = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*"
    }
};

export var createNewTemplate = function createNewTemplate(email, metadata, dataToSave) {
    return function (dispatch) {

        dispatch({ type: CREATE_NEW_TEMPLATE_START });

        var data = {
            email: email,
            metadata: metadata,
            signatures: dataToSave
        };

        axios.put(URL, data, axiosConfig).then(function (res) {
            dispatch({ type: "CREATE_NEW_TEMPLATE_SUCCESS", payload: res });
            swal({
                text: "Signature successfully created!",
                timer: 3000,
                buttons: false
            });
        }).catch(function (err) {
            dispatch({ type: "CREATE_NEW_TEMPLATE_FAILURE", payload: err });
            swal({
                title: "Something went wrong!",
                text: "Signature not created, please try again.",
                timer: 3000,
                buttons: false
            });
        });
    };
};

export var updateTemplate = function updateTemplate(email, metadata, dataToSave) {
    return function (dispatch) {

        dispatch({ type: UPDATE_TEMPLATE_START });

        var data = {
            email: email,
            metadata: metadata,
            signatures: dataToSave
        };

        axios.put(URL, data, axiosConfig).then(function (res) {
            dispatch({ type: "UPDATE_TEMPLATE_SUCCESS", payload: res });
            swal({
                text: "Signature successfully updated!",
                timer: 3000,
                buttons: false
            });
        }).catch(function (err) {
            dispatch({ type: "UPDATE_TEMPLATE_FAILURE", payload: err });
            swal({
                title: "Something went wrong!",
                text: "Signature not updated, please try again.",
                timer: 3000,
                buttons: false
            });
        });
    };
};

export var deleteSignature = function deleteSignature(email, metadata, dataToSave) {
    return function (dispatch) {

        dispatch({ type: DELETE_SIGNATURE_START });

        var data = {
            email: email,
            metadata: metadata,
            signatures: dataToSave
        };

        axios.put(URL, data, axiosConfig).then(function (res) {
            dispatch({ type: "DELETE_SIGNATURE_SUCCESS", payload: res });
            swal({
                text: "Signature successfully deleted!",
                timer: 3000,
                buttons: false
            });
        }).catch(function (err) {
            dispatch({ type: "DELETE_SIGNATURE_SUCCESS", payload: err });
            swal({
                title: "Something went wrong!",
                text: "Signature not deleted, please try again.",
                timer: 3000,
                buttons: false
            });
        });
    };
};

export var fetchSignature = function fetchSignature(email, id) {
    return function (dispatch) {
        //NEW

        dispatch({ type: FETCH_SIGNATURE_START });

        var defOrSet = id === undefined ? 0 : id;

        axios.get(URL + '?email=' + email).then(function (response) {
            if (!response.data && !response.data.url) {
                dispatch({ type: "FETCH_SIGNATURE_FAILURE", payload: { 'error': 'no url' } });
            }

            var findIndex = response.data.signatures !== undefined ? response.data.signatures.findIndex(function (d) {
                return d.id == defOrSet;
            }) : '';
            dispatch({ type: "FETCH_SIGNATURE_SUCCESS", payload: response.data.signatures === undefined ? response.data : response.data.signatures[findIndex] });
            console.log(response.data, 'from fetch');
            if (response.data.signatures === undefined) {
                swal({
                    title: "Signature selection",
                    text: "We have introduced an enhanced feature that allows you to create multiple signatures for a single user account. Currently, we have loaded your most recent signature information. Kindly assign a name to it, such as 'Default,' and save it accordingly."
                }).then(function (value) {
                    if (!value) {
                        swal({
                            title: "You did not press OK",
                            text: "If you do not give a name and save current Signature, details will be replaced by a new Signature."
                        });
                    }
                });
            }
        }).catch(function (err) {
            dispatch({ type: "FETCH_SIGNATURE_FAILURE", payload: err });
        });
    };
};

export var fetchTweets = function fetchTweets(data) {
    return function (dispatch) {
        dispatch({ type: FETCH_TWEETS_START });

        var username = data.username,
            count = data.count;


        axios.get('/api/signature/getTweets' + '?username=' + username + '&count=' + count).then(function (response) {

            if (response.status != 200 && !response.data) {
                dispatch({ type: "FETCH_TWEETS_FAILURE", payload: { 'error': response.statusText } });
            }

            dispatch({ type: "FETCH_TWEETS_SUCCESS", payload: response.data });
        }).catch(function (err) {
            dispatch({ type: "FETCH_TWEETS_FAILURE", payload: err });
        });
    };
};

export var fetchInstagramLastPost = function fetchInstagramLastPost(data) {
    return function (dispatch) {
        dispatch({ type: FETCH_INSTAGRAM_START });
        var username = data.username;


        var instagramRegExp = new RegExp(/<script type="text\/javascript">window\._sharedData = (.*)<\/script>/);
        axios.get('https://www.instagram.com/' + username, { crossdomain: true }).then(function (response) {
            //works only from browser
            var json = JSON.stringify(response.data.match(instagramRegExp)[1]);
            var jsonString = JSON.parse(json);
            var jsonObj = jsonString.replace(';', '');
            var result = JSON.parse(jsonObj);
            var instagramPost = result.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges[0].node;

            if (instagramPost) {
                dispatch({ type: "FETCH_INSTAGRAM_SUCCESS", payload: instagramPost });
            } else {
                res.send({ error: 'no values instagramPost' });
            }
        }).catch(function (err) {
            dispatch({ type: "FETCH_INSTAGRAM_FAILURE", payload: { instagramPostError: 'not found' } });
        });

        axios.get('/api/signature/instagramLastPost' + '?username=' + username).then(function (response) {
            if (response.status != 200 && !response.data) {
                dispatch({ type: "FETCH_INSTAGRAM_FAILURE", payload: { 'error': response.statusText } });
            }
            dispatch({ type: "FETCH_INSTAGRAM_SUCCESS", payload: response.data });
        }).catch(function (err) {
            dispatch({ type: "FETCH_INSTAGRAM_FAILURE", payload: err });
        });
    };
};


// WEBPACK FOOTER //
// ./node_modules/@int/signature/lib/containers/app/AppActions.js